import type { TextEntity } from 'views/App/Portal/Policy/DraftManuals/utils/textEntityProcessor';

/**
 * Returns the trimmed substitution value for a text entity key/label, or null if missing or blank.
 */
export function getResolvedTextEntityTooltipValue(
  textEntities: TextEntity[] | undefined,
  entityKey: string,
): string | null {
  if (!textEntities?.length || !entityKey) {
    return null;
  }

  const entity = textEntities.find((e) => e.key === entityKey || e.data.label === entityKey);
  const raw = entity?.data.value;
  if (raw == null) {
    return null;
  }
  const trimmed = String(raw).trim();
  return trimmed.length > 0 ? trimmed : null;
}
